import moment from "moment";
import { formatName } from "./user";

/**
 * Prepares common data for Pendo events related to patient applications
 * @param {Object} application - The application object
 * @param {Object} user - The current user object
 * @param {string} account - The account/site identifier
 * @param {Object} additionalData - Additional data specific to the event
 * @returns {Object} Prepared data object for Pendo tracking
 */
export const prepareDataForPendo = ({
  applicationId,
  patientId,
  potentialSaving,
  user,
  account,
  additionalData = {}
}) => ({
  patientId: patientId,
  userName: formatName(user),
  userEmail: user?.email,
  site: account,
  clickTimestamp: moment().local().format(),
  enrollmentId: applicationId,
  drugName:
    potentialSaving?.drugDisplayName ||
    potentialSaving?.approvedRxnormDrugs?.map((drug) => drug.tmDisplayName).join(", "),
  manufacturer: potentialSaving?.APProvider,
  programName: potentialSaving?.name,
  drugCui:
    potentialSaving?.matchedDrugCui || potentialSaving?.approvedRxnormDrugs?.map((drug) => drug.ttyCui).join(", "),
  supportsEE: potentialSaving?.hasExpressEnroll,
  ...additionalData
});
